import type { IDeliveryAddressView } from "@model/DeliveryAddress.model";
import { DELIVERY_ADDRESSES_SET_ITEMS } from "./DeliveryAddressesActionTypes";

export const setDeliveryAddressesItemsAction =
  (items: IDeliveryAddressView[]) => (dispatch: any) => {
    dispatch({
      type: DELIVERY_ADDRESSES_SET_ITEMS,
      payload: { items },
    });
  };
